import { render, staticRenderFns } from "./DemandInfo.vue?vue&type=template&id=1b5a3b81&"
import script from "./DemandInfo.vue?vue&type=script&lang=js&"
export * from "./DemandInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports